var map = {
	"./1inch.svg": 79352,
	"./BNB.svg": 15731,
	"./BRL.svg": 11945,
	"./BTC.svg": 29712,
	"./DOGE.svg": 99220,
	"./ETH.svg": 66604,
	"./Rivo.svg": 67385,
	"./TRX.svg": 15755,
	"./USDT.svg": 99027,
	"./aave.svg": 47758,
	"./ada.svg": 40009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53637;